<template>
 
         
        <el-form ref="form" label-width="450px" :model="form" size="small" :rules="rules">
        <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Project and End User Information</b>
        </div>
       
        <div>
            <span v-if="this.type === '0'">
                <el-form-item label="Project Name" prop="ProjectName">
                <el-input v-model="form.ProjectName" :disabled="true"></el-input>
            </el-form-item>

           <el-form-item label="date of receiving project" prop="DateofReceivingProject">
                <el-input v-model="form.DateofReceivingProject" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="last contact date" prop="LastContactDate">
                <el-input v-model="form.LastContactDate" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="latest project status update" prop="LatestProjectStatusUpdate">
                <el-input v-model="form.LatestProjectStatusUpdate" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="expected date of opening tender" prop="ExpectedDateofOpeningTender">
                <el-input v-model="form.ExpectedDateofOpeningTender" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="expected date of closing tender" prop="ExpectedDateofClosingTender">
                <el-input v-model="form.ExpectedDateofClosingTender" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="expected date of deployment/installation" prop="ExpectedDateofDeploymentInstallation">
                <el-input v-model="form.ExpectedDateofDeploymentInstallation" :disabled="true"></el-input>
            </el-form-item>

             <el-form-item label="Developer">
                <el-input v-model="form.Developer" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Project detail location (Address, City, Province, Country)" prop="ProjectLocation">
                <el-input v-model="form.ProjectLocation" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="End User Name" prop="EndUserName">
                <el-input v-model="form.EndUserName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="End User Website">
                <el-input v-model="form.EndUserWebsite" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="SIP PBX Brand">
                <el-input v-model="form.SIPPBXBrand" placeholder="If no SIP PBX , please enter NO" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Tested Akuvox Intercom to End User">
                <el-input v-model="form.TestedAkuvoxIntercomtoEndUser"  placeholder="YES？NO？" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="When to Deploy/Ship" prop="WhentoDeploy">
                <el-input v-model="form.WhentoDeploy" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="One-off Purchase Order or Partial Orders" prop="OneoffPurchaseOrderorPartialOrders">
                <el-input v-model="form.OneoffPurchaseOrderorPartialOrders" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Win Rate" prop="WinRate">
                <el-input v-model="form.WinRate" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
            <el-form-item label="Project Name" prop="ProjectName">
                <el-input v-model="form.ProjectName"></el-input>
            </el-form-item>

            <el-form-item label="date of receiving project" prop="DateofReceivingProject">
                <el-input v-model="form.DateofReceivingProject" ></el-input>
            </el-form-item>

             <el-form-item label="last contact date" prop="LastContactDate">
                <el-input v-model="form.LastContactDate" ></el-input>
            </el-form-item>

             <el-form-item label="latest project status update" prop="LatestProjectStatusUpdate">
                <el-input v-model="form.LatestProjectStatusUpdate" ></el-input>
            </el-form-item>

             <el-form-item label="expected date of opening tender" prop="ExpectedDateofOpeningTender">
                <el-input v-model="form.ExpectedDateofOpeningTender" ></el-input>
            </el-form-item>

            <el-form-item label="expected date of closing tender" prop="ExpectedDateofClosingTender">
                <el-input v-model="form.ExpectedDateofClosingTender" ></el-input>
            </el-form-item>

             <el-form-item label="expected date of deployment/installation" prop="ExpectedDateofDeploymentInstallation">
                <el-input v-model="form.ExpectedDateofDeploymentInstallation" ></el-input>
            </el-form-item>

             <el-form-item label="Developer">
                <el-input v-model="form.Developer" ></el-input>
            </el-form-item>

            <el-form-item label="Project detail location (Address, City, Province, Country)" prop="ProjectLocation">
                <el-input v-model="form.ProjectLocation" ></el-input>
            </el-form-item>

            <el-form-item label="End User Name" prop="EndUserName">
                <el-input v-model="form.EndUserName"></el-input>
            </el-form-item>

            <el-form-item label="End User Website">
                <el-input v-model="form.EndUserWebsite"></el-input>
            </el-form-item>

            <el-form-item label="SIP PBX Brand">
                <el-input v-model="form.SIPPBXBrand" placeholder="If no SIP PBX , please enter NO"></el-input>
            </el-form-item>

            <el-form-item label="Tested Akuvox Intercom to End User">
                <el-input v-model="form.TestedAkuvoxIntercomtoEndUser"  placeholder="YES？NO？"></el-input>
            </el-form-item>

            <el-form-item label="When to Deploy/Ship" prop="WhentoDeploy">
                <el-input v-model="form.WhentoDeploy"></el-input>
            </el-form-item>

            <el-form-item label="One-off Purchase Order or Partial Orders" prop="OneoffPurchaseOrderorPartialOrders">
                <el-input v-model="form.OneoffPurchaseOrderorPartialOrders"></el-input>
            </el-form-item>

            <el-form-item label="Win Rate" prop="WinRate">
                <el-input v-model="form.WinRate"></el-input>
            </el-form-item>
            </span>
            

            <p class="title">Brief Description of Project</p>
            <div id="briefDescriptionofProject" style="height:280px; padding-left:10px;"></div> 
            <br><br>
            <br>

            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Reseller/SI Information</b>
            </div>
             
            <span v-if="this.type === '0'">
            <el-form-item label="Company Name of Reseller/SI" prop="CompanyNameofReseller">
                <el-input v-model="form.CompanyNameofReseller" :disabled="true"></el-input>
            </el-form-item>
                        <br>
            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Contact</b>
            </div>

            <el-form-item label="Name">
                <el-input v-model="form.Name" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Tel">
                <el-input v-model="form.Tel" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Email">
                <el-input v-model="form.Email" :disabled="true"></el-input>
            </el-form-item>
            <br><br>

            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Akuvox Proposal</b>
            </div>

            <template v-for="(item,index) in form.Devices">

                <el-form-item :key="item.index" label="Model" :prop="'Devices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter a model', trigger: 'blur'}">
                    <el-input v-model="item.Model"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'Devices.'+index+'.Comments'" >
                    <el-input v-model="item.Comments"  :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
                <el-button :key="item.index" style="margin:10px 10px 10px 10px;" @click="deleteDevice(index)">-</el-button>
            </template>
            <el-button  @click="addDevice">+</el-button>
            <br><br>
            </span>
            <span v-else>
            <el-form-item label="Company Name of Reseller/SI" prop="CompanyNameofReseller">
                <el-input v-model="form.CompanyNameofReseller"></el-input>
            </el-form-item>
            <br>
            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Contact</b>
            </div>

            <el-form-item label="Name">
                <el-input v-model="form.Name"></el-input>
            </el-form-item>

            <el-form-item label="Tel">
                <el-input v-model="form.Tel"></el-input>
            </el-form-item>

            <el-form-item label="Email">
                <el-input v-model="form.Email"></el-input>
            </el-form-item>
            <br><br>

            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Akuvox Proposal</b>
            </div>

            <template v-for="(item,index) in form.Devices">

                <el-form-item :key="item.index" label="Model" :prop="'Devices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter a model', trigger: 'blur'}">
                    <el-input v-model="item.Model"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'Devices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'Devices.'+index+'.Comments'" >
                    <el-input v-model="item.Comments"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
                <el-button :key="item.index" style="margin:10px 10px 10px 10px;" @click="deleteDevice(index)">-</el-button>
            </template>
            <el-button  @click="addDevice">+</el-button>
            <br><br>
            </span>
             
            <div style="text-align:center;padding:20px 0; height:30px;">
            <b>Competitors Information</b>
            </div>
            
            <p class="title">Key Points of Akuvox to Win</p>
            <div id="keyPointsofAkuvoxtoWin" style="height:280px; padding-left:10px;"></div>
            <br><br>
            <br><br>

            <span  v-if="this.type === '0'">
                <template v-for="(item,index) in form.CompetitorDevices">

                <el-form-item :key="item.index" label="Competitor and its Model" :prop="'CompetitorDevices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter competitor and its model', trigger: 'blur'}">
                    <el-input v-model="item.Model" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'CompetitorDevices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'CompetitorDevices.'+index+'.Comments'"  >
                    <el-input v-model="item.Comments" :disabled="true"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
                <el-button :key="item.index" style="margin:10px 10px 10px 10px;" @click="deleteCompetitorDevice(index)">-</el-button>
            </template>
            <el-button  @click="addCompetitorDevice">+</el-button>
            </span>
            <span v-else>
                <template v-for="(item,index) in form.CompetitorDevices">

                <el-form-item :key="item.index" label="Competitor and its Model" :prop="'CompetitorDevices.'+index+'.Model'" :rules="{
                required: true, message: 'please enter competitor and its model', trigger: 'blur'}">
                    <el-input v-model="item.Model"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>

                <el-form-item :key="item.index" label="Quantity" :prop="'CompetitorDevices.'+index+'.Quantity'" :rules="{
                required: true, message: 'please enter a quantity', trigger: 'blur'}" >
                    <el-input v-model="item.Quantity"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  

                <el-form-item :key="item.index" label="Comments" :prop="'CompetitorDevices.'+index+'.Comments'"  >
                    <el-input v-model="item.Comments"></el-input><span style=" position: absolute; top: 1%; right: 2%;"> </span>
                </el-form-item>  
                <el-button :key="item.index" style="margin:10px 10px 10px 10px;" @click="deleteCompetitorDevice(index)">-</el-button>
            </template>
            <el-button  @click="addCompetitorDevice">+</el-button>
            </span>

            
            <br><br>
            <p class="title">Additional Info</p>
            <div id="additionalInfo" style="height:280px; padding-left:10px;"></div>
            <br><br>
            <br><br>
            <span  v-if="this.type === '0'">
                <el-form-item label="What help you need from Akuvox to win the project?">
                <el-input v-model="form.NeedHelp" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="What help you need from Akuvox to win the project?">
                <el-input v-model="form.NeedHelp"></el-input>
            </el-form-item>
            </span>

            <span  v-if="this.type === 'null'">
            <el-form-item label="Conclusion">
                <el-input v-model="form.Conclusion" :disabled="true"></el-input>
            </el-form-item>
            </span>
            <span v-else>
            <el-form-item label="Conclusion">
                <el-input v-model="form.Conclusion"></el-input>
            </el-form-item>
            </span>
            
            <br><br>
        </div>
        <div style="float:right;">
            <el-button @click="submit()" type="primary">Submit</el-button>
        </div>
        <br><br>
        <br><br>
        <br><br>
    </el-form>
</template>

<script>
export default {
    props:{
        id:{}
    },
    data () {
        return {
            
            briefDescriptionofProject:"",
            keyPointsofAkuvoxtoWin:"",
            additionalInfo:"",
            type:"",
            form:{
                ProjectName:"",

                DateofReceivingProject:"",
                LastContactDate:"",
                LatestProjectStatusUpdate:"",
                ExpectedDateofOpeningTender:"",
                ExpectedDateofClosingTender:"",
                ExpectedDateofDeploymentInstallation:"",
                Developer:"",

                ProjectLocation:"",
                EndUserName:"",
                EndUserWebsite:"",
                SIPPBXBrand:"",
                
                TestedAkuvoxIntercomtoEndUser:"",
                WhentoDeploy:"",
                OneoffPurchaseOrderorPartialOrders:"",
                WinRate:"",
                CompanyNameofReseller:"",

                Name:"",
                Tel:"",
                Email:"",
                Devices:[{
                    Model:"",
                    Quantity:"",
                    Comments:""
                }],
                CompetitorDevices:[{
                    Model:"",
                    Quantity:"",
                    Comments:""
                }],
                Conclusion:"",
                NeedHelp:""
            },
            rules:{
                ProjectName:[{ required: true, message: 'Please enter your Project name', trigger: 'blur' }],
                ProjectLocation:[{ required: true, message: 'Please enter your Project Location', trigger: 'blur' }],
                EndUserName:[{ required: true, message: 'Please enter your end user name', trigger: 'blur' }],
                WhentoDeploy:[{ required: true, message: 'Please fill in when to Deploy', trigger: 'blur' }],
                WinRate:[{ required: true, message: '>70% / <70%,>40% / <40%', trigger: 'blur' }],
                CompanyNameofReseller:[{ required: true, message: 'Please fill in a company name of reseller', trigger: 'blur' }],
                KeyPointsofAkuvoxtoWin:[{ required: true, message: 'Please fill in a key points of Akuvox to win', trigger: 'blur' }],
                DateofReceivingProject:[{ required: true, message: 'Please enter your date of receiving project', trigger: 'blur' }],
                LastContactDate:[{ required: true, message: 'Please enter your last contact date', trigger: 'blur' }],
                LatestProjectStatusUpdate:[{ required: true, message: 'Please select your latest project status update', trigger: 'blur' }],
                ExpectedDateofDeploymentInstallation:[{ required: true, message: 'Please enter your expected date of deployment/installation', trigger: 'blur' }]
            }
        };
    },
    mounted () {
        this.createEditor("briefDescriptionofProject");
        this.createEditor("keyPointsofAkuvoxtoWin");
        this.createEditor("additionalInfo");
        this.type = localStorage.getItem("type");
        
    },
    created () {
        if(this.id)
            this.$http.get("getProjectRegistrationInfo",{
                ID:this.id
            },(data)=>{
                data = data.data;
                this.form.ProjectName = data.ProjectName;

                this.form.DateofReceivingProject = data.DateofReceivingProject;
                this.form.LastContactDate = data.LastContactDate;
                this.form.LatestProjectStatusUpdate = data.LatestProjectStatusUpdate;
                this.form.ExpectedDateofOpeningTender = data.ExpectedDateofOpeningTender;
                this.form.ExpectedDateofClosingTender = data.ExpectedDateofClosingTender;
                this.form.ExpectedDateofDeploymentInstallation = data.ExpectedDateofDeploymentInstallation;
                this.form.Developer = data.Developer;

                this.form.ProjectLocation = data.ProjectLocation;
                this.form.EndUserName = data.EndUserName;
                this.form.EndUserWebsite = data.EndUserWebsite;
                this.form.SIPPBXBrand = data.SIPPBXBrand;

                this.form.TestedAkuvoxIntercomtoEndUser = data.TestedAkuvoxIntercomtoEndUser;
                this.form.WhentoDeploy = data.WhentoDeploy;
                this.form.OneoffPurchaseOrderorPartialOrders = data.OneoffPurchaseOrderorPartialOrders;
                this.form.WinRate = data.WinRate;
                this.form.CompanyNameofReseller = data.CompanyNameofReseller;

                this.form.Name = data.Name;
                this.form.Tel = data.Tel;
                this.form.Name = data.Name;
                this.form.Conclusion = data.Conclusion;
                this.form.NeedHelp = data.NeedHelp;
                this.form.Devices = data.Devices;
                this.form.CompetitorDevices = data.CompetitorDevices;
                
                this.briefDescriptionofProject.txt.html(data.BriefDescriptionofProject);
                if (this.type === '0')
                {
                    this.briefDescriptionofProject.$textElem.attr('contenteditable',false);
                }
                this.keyPointsofAkuvoxtoWin.txt.html(data.KeyPointsofAkuvoxtoWin);
                if (this.type === '0')
                {
                    this.keyPointsofAkuvoxtoWin.$textElem.attr('contenteditable',false);
                }
                this.additionalInfo.txt.html(data.AdditionalInfo);
                if (this.type === '0')
                {
                    this.additionalInfo.$textElem.attr('contenteditable',false);
                }
                
            });
    },
    methods:{
        createEditor (val) {
            let E = window.wangEditor;
            this[val] = new E('#'+val);
            this[val].customConfig.zIndex = 100;
            this[val].customConfig.uploadImgShowBase64 = true;
            this[val].customConfig.uploadFileServer = `${this.$http.host}partnerManageServer/uploadDownloadFileProjectRegistration`;
            this[val].customConfig.downloadFileServer = `${this.$http.host}akuvoxwiki/download/partnerManage/projectRegistration`;
            this[val].create();
        },
        submit () {
            if(!(this.form.ProjectName && this.form.ProjectLocation && this.form.EndUserName && this.form.WhentoDeploy && this.form.WinRate && this.form.CompanyNameofReseller && this.form.Devices !== [] && this.form.CompetitorDevices !== [])) {
                this.$message.error('You have missed some mandatory information. ');
                return;
            }
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let form = Object.assign({},this.form);
                let methods = !this.id ? 'post' : 'put';
                let url = !this.id ? 'addProjectRegistration' : 'editProjectRegistration';
                this.$http[methods](url,{
                    ID:this.id,
                    ProjectName : form.ProjectName,

                    DateofReceivingProject : form.DateofReceivingProject,
                    LastContactDate : form.LastContactDate,
                    LatestProjectStatusUpdate : form.LatestProjectStatusUpdate,
                    ExpectedDateofOpeningTender : form.ExpectedDateofOpeningTender,
                    ExpectedDateofClosingTender : form.ExpectedDateofClosingTender,
                    ExpectedDateofDeploymentInstallation : form.ExpectedDateofDeploymentInstallation,
                    Developer : form.Developer,

                    ProjectLocation : form.ProjectLocation,
                    EndUserName : form.EndUserName,
                    EndUserWebsite : form.EndUserWebsite,
                    SIPPBXBrand : form.SIPPBXBrand,

                    TestedAkuvoxIntercomtoEndUser : form.TestedAkuvoxIntercomtoEndUser,
                    WhentoDeploy : form.WhentoDeploy,
                    OneoffPurchaseOrderorPartialOrders : form.OneoffPurchaseOrderorPartialOrders,
                    WinRate : form.WinRate,
                    CompanyNameofReseller : form.CompanyNameofReseller,

                    Name : form.Name,
                    Tel : form.Tel,
                    Email : form.Email,
                    Conclusion : form.Conclusion,
                    NeedHelp : form.NeedHelp,

                    Devices : JSON.stringify(form.Devices),
                    CompetitorDevices : JSON.stringify(form.CompetitorDevices),
                    BriefDescriptionofProject:this.briefDescriptionofProject.txt.html(),
                    KeyPointsofAkuvoxtoWin:this.keyPointsofAkuvoxtoWin.txt.html(),
                    AdditionalInfo:this.additionalInfo.txt.html()
                },(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$router.push("/projectRegistration");
                });
            });
        },
        addDevice () {
            this.$set(this.form.Devices,this.form.Devices.length,{
                Model:"",
                Quantity:"",
                Comments:""
            });
        },
        deleteDevice (index) {
            this.$delete(this.form.Devices,index);
        },
        addCompetitorDevice () {
            this.$set(this.form.CompetitorDevices,this.form.CompetitorDevices.length,{
                Model:"",
                Quantity:"",
                Comments:""
            });
        },
        deleteCompetitorDevice (index) {
            this.$delete(this.form.CompetitorDevices,index);
        }
    }
};
</script>
<style lang="less" scoped>
    .title{
        padding: 20px 0 0px 10px;
        display: block;
    }
</style>

